




















































































import {
    computed,
    defineComponent,
    toRefs,
    PropType,
} from '@vue/composition-api';
import EventTime from './EventTime.vue';
import EventCompetitor from './EventCompetitor.vue';
import EventMediaSection from './EventMediaSection.vue';
import ScoreWidget from './ScoreWidget.vue';
import EventPin from './EventPin.vue';
import OfferEvent from '@core/models/offer/OfferEvent';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import tvChannels from '@sportOfferFederation/tvChannels/store/index';
import { BetslipStore } from '@store/modules/ui/betSlip';
import { useCompetitorStats } from './composeable/useCompetitorStats';

export default defineComponent({
    name: 'Event',
    emits: ['pinClick'],
    props: {
        event: {
            type: Object as PropType<OfferEvent>,
            required: true,
        },
        expandedEvent: {
            type: Number,
            default: null,
        },
        useCompactLiveData: {
            type: Boolean,
            default: false,
        },
        isPinShown: {
            type: Boolean,
            required: true,
        },
        isEventPinned: {
            type: Boolean,
            required: false,
            default: false,
        },
        e2eClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const { event } = toRefs(props);

        const tvChannelsStore = useVuexStore<typeof tvChannels>('data/tvChannels');
        const betslipStore = useVuexStore<BetslipStore>('ui/sportOffer/betSlip');
        const channels = tvChannelsStore.getter('betRadarIdToChannels');
        const {
            isLive,
            isFirstLeading,
            isSecondLeading,
            isFirstServing,
            isSecondServing,
        } = useCompetitorStats(event);

        return {
            isCodeShown: betslipStore.getter('isCodeShown'),
            broadcast: computed(() => props.event.betRadarId ? channels.value[props.event.betRadarId] : null),
            isLive,
            isFirstLeading,
            isSecondLeading,
            isFirstServing,
            isSecondServing,
        };
    },
    components: {
        EventTime,
        EventCompetitor,
        EventMediaSection,
        ScoreWidget,
        EventPin,
    },
});
